export default __webpack_public_path__ + "static/media/ucy.64f83b77.png";